import { Loader } from '@comall-backend-builder/core/lib/loaders';
import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';

const api = services.api;

// 免密登录
export const SSOLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        const response: any = await api.get(params, config);
        response.name = response.username;
        return response;
    },
};
